import { render } from "./QueryTab.vue?vue&type=template&id=358e74d4"
import script from "./QueryTab.vue?vue&type=script&lang=js"
export * from "./QueryTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DD6576\\tourbillon-timescale\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__